import { ContentPlanForm } from './forms/content-plan-form';
import { CustomerPersonaForm } from './forms/customer-persona-form';
import { GettingToKnowYouForm } from './forms/getting-to-know-you-form';
import { ToneOfVoiceForm } from './forms/tone-of-voice-form';
import { ValuePropositionForm } from './forms/value-proposition-form';

export type StrategySection =
  | 'customer-personas'
  | 'value-proposition'
  | 'getting-to-know-you'
  | 'tone-of-voice'
  | 'content-plan';

interface StrategySectionContentProps {
  selectedSection: StrategySection;
  projectId: string;
}

/**
 * Renders the content area for the selected strategy section.
 */
export const StrategySectionContent = ({
  selectedSection,
  projectId,
}: StrategySectionContentProps) => {
  if (selectedSection === 'customer-personas') {
    return <CustomerPersonaForm projectId={projectId} />;
  }

  if (selectedSection === 'value-proposition') {
    return <ValuePropositionForm projectId={projectId} />;
  }

  if (selectedSection === 'getting-to-know-you') {
    return <GettingToKnowYouForm projectId={projectId} />;
  }

  if (selectedSection === 'tone-of-voice') {
    return <ToneOfVoiceForm />;
  }

  if (selectedSection === 'content-plan') {
    return <ContentPlanForm />;
  }
};

export default StrategySectionContent;
